export interface AlgoliaClinicV2 {
  objectID: string;
  ambulatoryId: string;
  name: string;
  description: string;
  website: string;
  logoUrl?: string;
  license: License;
  licenseOrder: number;
  address?: string | null;
  cap?: string | null;
  city?: string | null;
  district: string;
  slug: string;
  _geoloc?: {
    lat: number;
    lng: number;
  };
  phones?: string[] | null;
  specializations: Speciality;
  domiciliaryCare: boolean;
  offerOnlineServices: boolean;
  /** First available date for a visit in UNIX timestamp format */
  firstAvailableVisitTimestamp?: number;
  availablePayments: PaymentType[];
  /** Epoch timestamp for last import */
  existsAvailabilities?: boolean;
  importRun?: number;
  distinctId: string;
  /** Minimum booking delay in milliseconds; if > 0, availability requests use startDate >= now + delayAvailability */
  delayAvailability?: number;
  _rankingInfo?: {
    geoDistance: number;
  };
  review: Review | null;
  isIntegrated?: boolean;
}
export type Speciality = {
  hasDescription: boolean;
  doctors?: Doctor[];
  favorite?: boolean;
  id?: string;
  label: string;
  macroSpeciality?: string | null;
  macroSpecialityKey?: string | null;
  specialityChannels?: SpecialityChannel[];
  hasDynamicPrice: boolean;
  __typename?: string;
};
export enum SpecialityChannel {
  Domiciliary = 'DOMICILIARY',
  Online = 'ONLINE',
  Onsite = 'ONSITE',
}
export type Doctor = {
  id: string;
  isNameVisible: boolean;
  name: string;
  sex?: Sex | null;
  surname: string;
  taxCode?: string | null;
  nextAvailability?: number | null;
  price: number | undefined;
  minPrice?: number;
};
enum Sex {
  Female = 'FEMALE',
  Male = 'MALE',
}
export enum PaymentType {
  Deferred = 'DEFERRED',
  Online = 'ONLINE',
  Onlywithcoupon = 'ONLYWITHCOUPON',
  Onsite = 'ONSITE',
}
export enum License {
  None = 'NONE',
  Premium = 'PREMIUM',
  Standard = 'STANDARD',
}

export type SpecializationDetail = {
  _id?: string;
  channels?: string[];
  service?: string;
  specialization?: string;
};

export type SpecializationDoctor = Node & {
  _id: string;
  sex?: Sex;
};

export type Specialization = {
  detail?: SpecializationDetail;
  doctor?: SpecializationDoctor;
  favorite?: boolean;
  price?: number;
};

export type Review = {
  clinicName: string;
  rating: string;
  textReview: string;
};
